import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/PromotionsTable.styles'

interface PromotionRowSkeletonProps {
  mobile?: boolean
}

// Reads the same style module as the rows, so the placeholder sits on the identical grid and
// nothing shifts when real data arrives.
const PromotionRowSkeleton: React.FC<PromotionRowSkeletonProps> = ({
  mobile
}) => {
  const classes = useStyles()
  const cells = mobile ? [0, 1, 2] : [0, 1, 2, 3, 4]

  return (
    <div className={mobile ? classes.tableRowMobile : classes.tableRow}>
      {cells.map((cell) => (
        <div key={cell}>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
      ))}
      <div />
    </div>
  )
}

export default PromotionRowSkeleton
